import { entryTags } from "@/mocks/homeData";

export default function TagEntries() {
  return (
    <section id="entries" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto max-w-5xl px-4 md:px-8">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
          <div>
            <p className="flex items-center gap-2 text-xs font-semibold tracking-[0.25em] text-secondary-700 md:text-sm">
              <i className="ri-compass-3-line"></i>
              ENTRY NAVIGATION
            </p>
            <h2 className="mt-3 font-heading text-3xl font-black text-foreground-950 md:text-5xl">入口导航</h2>
            <p className="mt-4 text-sm leading-loose text-foreground-600 md:text-base">
              想快速进站就点标签。我们把黑料bu入口、黑料bu新料入口常被搜索的方向都整理在了这里，直接跳转到对应的分区，不用一层层翻。
            </p>
            <div className="mt-8 flex flex-col gap-3 border-t border-background-300 pt-6">
              <span className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-price-tag-3-line text-secondary-600"></i>
                12 个高频入口
              </span>
              <span className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-refresh-line text-secondary-600"></i>
                标签随热度自动置顶
              </span>
              <span className="flex items-center gap-2 text-sm text-foreground-700">
                <i className="ri-shield-check-line text-secondary-600"></i>
                所有材料均标注来源
              </span>
            </div>
          </div>

          <div className="flex flex-wrap content-start gap-3">
            {entryTags.map((tag, index) => (
              <a
                key={tag}
                href={index % 2 === 0 ? "#feed" : "#materials"}
                className={`rounded-full border px-4 py-2.5 text-sm font-medium transition-colors md:px-5 ${
                  index < 4
                    ? "border-primary-200 bg-primary-100 text-primary-800 hover:bg-primary-200"
                    : "border-background-300 bg-background-50 text-foreground-700 hover:border-secondary-300 hover:bg-secondary-100 hover:text-secondary-900"
                }`}
              >
                {tag}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}